angular.module("ainapp")
    .controller("FlatStatusController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Flat Status";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.Filter = {
                    Status: "Vacant",
                }

                $scope.load = 0;

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Status = $scope.Filter.Status;
                        MainService.FlatInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            FlatNo: {
                                type: "string",
                                editable: false,
                            },
                            FloorNo: {
                                type: "string",
                                editable: false,
                            },
                            Area: {
                                type: "number",
                                editable: false,
                            },
                            BedRooms: {
                                type: "number",
                                editable: false,
                            },
                            BathRooms: {
                                type: "number",
                                editable: false,
                            },
                            AvgRate: {
                                type: "number",
                                editable: false,
                            },
                            FlatType: {
                                type: "string",
                                editable: false,
                            },
                            ContractNo: {
                                type: "string",
                                editable: false,
                            },
                            Status: {
                                type: "string",
                                editable: false,
                            },
                            "Building.Name": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "FlatNo",
                        title: "Flat No",
                        },
                    {
                        field: "Building.Name",
                        title: "Building",
                        },
                    {
                        field: "FloorNo",
                        title: "Floor No",
                        },
                    {
                        field: "Area",
                        title: "Area",
                        },
                    {
                        field: "AvgRate",
                        title: "Avg Rate",
                        },
                    {
                        field: "FlatType",
                        title: "Flat Type",
                        }, {
                        field: "ContractNo",
                        title: "Contract No",
                        },
                    {
                        field: "Status",
                        title: "Status",
                        },
                    ],
            };

            $scope.filterData = function (temp) {
                $scope.Filter.Status = temp;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

        }])
